<ul class="content-block-list">
  <li
    class="content-block-list__item"
    *ngFor="let block of blocks; let i = index; trackBy: trackByFn"
    [ngSwitch]="block.blockType"
    [ngClass]="getCountClass(block) + (' block--' + block.blockType)"
    [class.has--text-only]="!block.image.url"
  >
    <app-content-block-fullwidth *ngSwitchCase="'full-width'" [block]="block"></app-content-block-fullwidth>
    <app-content-block-logos [block]="block" *ngSwitchCase="'block_logos'"></app-content-block-logos>
    <app-content-block-tips [block]="block" *ngSwitchCase="'block_tips'"></app-content-block-tips>
    <app-content-block-steps *ngSwitchCase="'block_steps'" [block]="block"></app-content-block-steps>
    <app-content-block-rte [block]="block" *ngSwitchCase="'block_rte'"></app-content-block-rte>
    <app-content-block-default *ngSwitchDefault [block]="block"></app-content-block-default>
  </li>
</ul>
